module.exports = __webpack_public_path__ + "static/media/repeat-1-alt.74a3d581.svg";